import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"min-width":"80vw"} }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "pl-2" }
const _hoisted_4 = {
  key: 0,
  class: "pr-2"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "pr-2"
}
const _hoisted_9 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "pr-2"
}
const _hoisted_12 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_TagEditionDialog = _resolveComponent("TagEditionDialog")!
  const _component_MergeTags = _resolveComponent("MergeTags")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tabStep,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabStep) = $event)),
      "fixed-tabs": "",
      style: {"background-color":"transparent !important","border-radius":"16px","overflow":"hidden"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "tagTab" }, {
          default: _withCtx(() => _cache[35] || (_cache[35] = [
            _createElementVNode("strong", null, "Etiquettes", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "logTab" }, {
          default: _withCtx(() => _cache[36] || (_cache[36] = [
            _createElementVNode("strong", null, "Journaux", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "accessRightTab" }, {
          default: _withCtx(() => _cache[37] || (_cache[37] = [
            _createElementVNode("strong", null, "Cellule", -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_tabs_window, {
      modelValue: _ctx.tabStep,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tabStep) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, {
          key: "tagTab",
          value: "tagTab"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "pb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "mt-2 d-flex justify-start"
                }, {
                  default: _withCtx(() => [
                    (_ctx.viewMode === 1)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "mb-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  size: "small",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAllTags()))
                                }, {
                                  default: _withCtx(() => _cache[38] || (_cache[38] = [
                                    _createTextVNode(" Sélectionner tout ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "mb-2 pl-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  size: "small",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.diselectAllTags()))
                                }, {
                                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                                    _createTextVNode(" Désélectionner tout ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    (_ctx.viewMode === 1)
                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                          key: 0,
                          modelValue: _ctx.selectedTagType,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTagType) = $event)),
                          items: _ctx.tagTypes,
                          class: "mt-2",
                          "hide-details": "",
                          label: "Filtrer par type",
                          density: "compact",
                          "item-title": (item) => item.text
                        }, null, 8, ["modelValue", "items", "item-title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "d-flex justify-end"
                }, {
                  default: _withCtx(() => [
                    (_ctx.viewMode === 1 && _ctx.hasTagDistribution)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps({
                              class: "mr-2",
                              onClick: _ctx.mergeSelectedTags
                            }, props, {
                              disabled: true,
                              size: "small"
                            }), {
                              default: _withCtx(() => _cache[40] || (_cache[40] = [
                                _createTextVNode(" Fusionner ")
                              ])),
                              _: 2
                            }, 1040, ["onClick"])
                          ]),
                          default: _withCtx(() => [
                            _cache[41] || (_cache[41] = _createElementVNode("span", null, "La fusion est impossible avec un tag de type TagDistribution.", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.viewMode === 1 && !_ctx.hasTagDistribution)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          class: "mr-2",
                          onClick: _ctx.mergeSelectedTags,
                          disabled: _ctx.mergeDisabled,
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                            _createTextVNode(" Fusionner ")
                          ])),
                          _: 1
                        }, 8, ["onClick", "disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.viewMode === 1)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 2,
                          elevation: "0",
                          class: "mr-2",
                          rounded: "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteSelectedTags())),
                          disabled: !_ctx.selectedTags.length,
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[43] || (_cache[43] = [
                            _createTextVNode(" Supprimer ")
                          ])),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.viewMode,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.viewMode) = $event)),
                      mandatory: "",
                      density: "compact",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_icon, {
                          value: 0,
                          icon: "$fa-columns"
                        }),
                        _createVNode(_component_v_btn_icon, {
                          value: 1,
                          icon: "$fa-th-list"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window, {
                      modelValue: _ctx.viewMode,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.viewMode) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, { value: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "pa-2"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.unclassedPartitionTag && !_ctx.accountingFirmId)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 0,
                                          "no-gutters": "",
                                          style: {"border-radius":"12px","background":"#f8f8f8"},
                                          class: "pa-2 mb-2 elevation-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "7",
                                              class: "title d-flex"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.unclassedPartitionTag.name), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "my-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_draggable, {
                                                  id: _ctx.unclassedPartitionTag.id,
                                                  list: _ctx.unclassedPartitionTag.tags,
                                                  class: "list-group",
                                                  draggable: ".item",
                                                  group: "a",
                                                  onChange: _cache[6] || (_cache[6] = ($event: any) => (
                                                        _ctx.updateTag($event, _ctx.unclassedPartitionTag.id)
                                                    ))
                                                }, {
                                                  item: _withCtx(({ element: tag }) => [
                                                    (_openBlock(), _createElementBlock("div", {
                                                      class: "list-group-item item px-2 py-1 mr-2 mt-1 d-flex",
                                                      style: {"width":"fit-content !important","float":"left"},
                                                      key: tag.id,
                                                      onClick: _withModifiers(($event: any) => (_ctx.editTag(tag)), ["stop"])
                                                    }, [
                                                      _createElementVNode("span", null, _toDisplayString(tag.name), 1),
                                                      _createElementVNode("div", _hoisted_3, [
                                                        _createVNode(_component_v_icon, {
                                                          dense: "",
                                                          onClick: _withModifiers(($event: any) => (
                                                                        _ctx.checkDeleteTag(tag.id)
                                                                    ), ["stop"]),
                                                          size: "x-small"
                                                        }, {
                                                          default: _withCtx(() => _cache[44] || (_cache[44] = [
                                                            _createTextVNode("$oss-trash")
                                                          ])),
                                                          _: 2
                                                        }, 1032, ["onClick"])
                                                      ])
                                                    ], 8, _hoisted_2))
                                                  ]),
                                                  _: 1
                                                }, 8, ["id", "list"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "d-flex align-center pt-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: _ctx.newTags[_ctx.unclassedPartitionTag.key],
                                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newTags[_ctx.unclassedPartitionTag.key]) = $event)),
                                                  "append-inner-icon": "$add",
                                                  label: "Nom du nouveau tag",
                                                  color: "primary",
                                                  outlined: "",
                                                  "hide-details": "",
                                                  density: "compact",
                                                  "onClick:appendInner": _cache[8] || (_cache[8] = ($event: any) => (
                                                        _ctx.createTag(_ctx.unclassedPartitionTag)
                                                    ))
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "pa-2 my-2 elevation-0",
                                      style: {"border-radius":"12px","background":"#f8f8f8"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "10",
                                          class: "pr-2 d-flex align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                              modelValue: _ctx.partitionName,
                                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.partitionName) = $event)),
                                              outlined: "",
                                              label: "Nom de la partition",
                                              "hide-details": "",
                                              density: "compact"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "d-flex align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              rounded: "",
                                              elevation: "0",
                                              disabled: !_ctx.partitionName,
                                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.createPartitionTag())),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                _createTextVNode("Créer")
                                              ])),
                                              _: 1
                                            }, 8, ["disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.scopingPartitionTags.length)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 1,
                                          "no-gutters": ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_divider),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "mt-2"
                                            }, {
                                              default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                _createElementVNode("span", { class: "title" }, "Partitions de mon cabinet", -1)
                                              ])),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scopingPartitionTags, (partition, index) => {
                                              return (_openBlock(), _createBlock(_component_v_col, {
                                                cols: "12",
                                                class: "mt-2",
                                                key: index
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, {
                                                    "no-gutters": "",
                                                    class: "pa-2 my-2 elevation-0",
                                                    style: {"border-radius":"12px","background":"#f8f8f8"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "9",
                                                        class: "pr-2 d-flex align-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(partition.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_col, {
                                                        cols: "3",
                                                        class: "d-flex align-right justify-end"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (
                                                                partition &&
                                                                partition.id !== 'WithoutId'
                                                            )
                                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 0,
                                                                rounded: "",
                                                                elevation: "0",
                                                                onClick: ($event: any) => (
                                                                _ctx.duplicatePartitionAccountingFirm(
                                                                    partition,
                                                                )
                                                            ),
                                                                disabled: 
                                                                _ctx.isPartitionUsed(partition.id)
                                                            ,
                                                                size: "small",
                                                                block: ""
                                                              }, {
                                                                default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                                  _createTextVNode(" Appliquer ")
                                                                ])),
                                                                _: 2
                                                              }, 1032, ["onClick", "disabled"]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "my-3"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partition.tags, (tag) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              class: "list-group-item item px-2 py-1 mr-2 mt-1 d-flex",
                                                              style: {"width":"fit-content !important","float":"left"},
                                                              key: tag.id
                                                            }, [
                                                              (partition.type === 'Building')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                                    _createVNode(_component_v_icon, {
                                                                      dense: "",
                                                                      size: "x-small"
                                                                    }, {
                                                                      default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                                        _createTextVNode("$fa-building")
                                                                      ])),
                                                                      _: 1
                                                                    })
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              _createElementVNode("span", null, _toDisplayString(tag.name), 1)
                                                            ]))
                                                          }), 128))
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "pa-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classedPartitionTags, (partition, index) => {
                                          return (_openBlock(), _createBlock(_component_v_col, {
                                            cols: "12",
                                            key: index
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, {
                                                "no-gutters": "",
                                                style: {"border-radius":"12px","background":"#f8f8f8"},
                                                class: "mb-2 pa-2 elevation-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "8",
                                                    class: "title d-flex"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(partition.name) + " ", 1),
                                                      (
                                                                partition.id !== 'WithoutId' &&
                                                                !partition.primaryLog
                                                            )
                                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                            key: 0,
                                                            location: "bottom"
                                                          }, {
                                                            activator: _withCtx(({ props }) => [
                                                              _createVNode(_component_v_btn_icon, _mergeProps({
                                                                icon: "$oss-edit",
                                                                ref_for: true
                                                              }, props, {
                                                                color: "primary",
                                                                class: "ml-2",
                                                                onClick: ($event: any) => (
                                                                        _ctx.editPartition(partition)
                                                                    ),
                                                                size: "small"
                                                              }), null, 16, ["onClick"])
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _cache[49] || (_cache[49] = _createElementVNode("span", null, "Editer la partition", -1))
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true),
                                                      (
                                                                partition.id !== 'WithoutId' &&
                                                                !partition.primaryLog &&
                                                                !_ctx.disabledDeleteTag(partition)
                                                            )
                                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                            key: 1,
                                                            location: "bottom"
                                                          }, {
                                                            activator: _withCtx(({ props }) => [
                                                              _createVNode(_component_v_btn_icon, _mergeProps({
                                                                icon: "$oss-trash",
                                                                ref_for: true
                                                              }, props, {
                                                                color: "primary",
                                                                class: "ml-2",
                                                                onClick: ($event: any) => (
                                                                        _ctx.deletePartition(
                                                                            partition.id,
                                                                        )
                                                                    ),
                                                                size: "small"
                                                              }), null, 16, ["onClick"])
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _cache[50] || (_cache[50] = _createElementVNode("span", null, "Supprimer la partition", -1))
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, {
                                                    cols: "4",
                                                    class: "d-flex align-center justify-end"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (
                                                                partition &&
                                                                partition.id !== 'WithoutId' &&
                                                                !partition.primaryLog
                                                            )
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 0,
                                                            rounded: "",
                                                            class: "ml-2",
                                                            elevation: "0",
                                                            onClick: ($event: any) => (
                                                                _ctx.openNewTagDistributionDialog(
                                                                    partition,
                                                                )
                                                            ),
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[51] || (_cache[51] = [
                                                              _createTextVNode(" Ajouter une Distribution ")
                                                            ])),
                                                            _: 2
                                                          }, 1032, ["onClick"]))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  (partition.companyScope)
                                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                                        key: 0,
                                                        cols: "12"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", null, [
                                                            _createVNode(_component_v_icon, {
                                                              "x-small": "",
                                                              class: "mr-2"
                                                            }, {
                                                              default: _withCtx(() => _cache[52] || (_cache[52] = [
                                                                _createTextVNode("$fa-bullseye")
                                                              ])),
                                                              _: 1
                                                            }),
                                                            _createTextVNode(_toDisplayString(_ctx.getTargets(partition.companyScope)), 1)
                                                          ]),
                                                          _createElementVNode("div", null, [
                                                            (
                                                                    partition.companyScope &&
                                                                    partition.companyScope
                                                                        .accountingCompanyOwner &&
                                                                    partition.companyScope
                                                                        .accountingCompanyOwner
                                                                        .name &&
                                                                    partition.companyScope
                                                                        .accountingCompanyOwner
                                                                        .name !== 'OSS360'
                                                                )
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString("Créée par " +
                                                                    partition.companyScope
                                                                        .accountingCompanyOwner.name), 1))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_6, " Créée par bobbee "))
                                                          ])
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true),
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    class: "my-3"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_draggable, {
                                                        id: partition.id,
                                                        list: partition.tags,
                                                        class: "list-group",
                                                        draggable: ".item",
                                                        group: "a",
                                                        onChange: ($event: any) => (
                                                                _ctx.updateTag($event, partition.id)
                                                            )
                                                      }, {
                                                        item: _withCtx(({ element: tag }) => [
                                                          (_openBlock(), _createElementBlock("div", {
                                                            class: "list-group-item item px-2 py-1 mr-2 mt-1 d-flex",
                                                            style: {"width":"fit-content !important","float":"left"},
                                                            key: tag.id,
                                                            onClick: _withModifiers(($event: any) => (_ctx.editTag(tag)), ["stop"])
                                                          }, [
                                                            (
                                                                            partition.type ===
                                                                            'Building'
                                                                        )
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                                  _createVNode(_component_v_icon, {
                                                                    dense: "",
                                                                    size: "x-small"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                                                                      _createTextVNode("$fa-building")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("span", null, _toDisplayString(tag.name), 1),
                                                            (
                                                                            !_ctx.disabledDeleteTag(
                                                                                partition,
                                                                            )
                                                                        )
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                                  _createVNode(_component_v_icon, {
                                                                    dense: "",
                                                                    onClick: _withModifiers(($event: any) => (
                                                                                _ctx.checkDeleteTag(
                                                                                    tag.id,
                                                                                )
                                                                            ), ["stop"]),
                                                                    size: "x-small"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                                                                      _createTextVNode("$oss-trash")
                                                                    ])),
                                                                    _: 2
                                                                  }, 1032, ["onClick"])
                                                                ]))
                                                              : _createCommentVNode("", true)
                                                          ], 8, _hoisted_7))
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["id", "list", "onChange"])
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    class: "d-flex align-center pt-3"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_text_field, {
                                                        modelValue: _ctx.newTags[partition.key],
                                                        "onUpdate:modelValue": ($event: any) => ((_ctx.newTags[partition.key]) = $event),
                                                        "append-inner-icon": "$add",
                                                        label: "Nom du nouveau tag",
                                                        color: "primary",
                                                        outlined: "",
                                                        "hide-details": "",
                                                        density: "compact",
                                                        "onClick:appendInner": ($event: any) => (
                                                                _ctx.createTag(partition)
                                                            )
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick:appendInner"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "py-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"overflow-y":"auto","height":"calc(100vh - 205px)"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, {
                                      subheader: "",
                                      density: "compact",
                                      lines: "two"
                                    }, {
                                      default: _withCtx(() => [
                                        (!_ctx.tags.length)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              class: _normalizeClass(
                                                        !_ctx.$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    )
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[55] || (_cache[55] = [
                                                    _createTextVNode(" Aucun tag n'a été trouvé ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["class"]))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTags, (tag, i) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                                            (!tag.primaryLog)
                                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                  key: i + tag.id,
                                                  class: _normalizeClass(
                                                        !_ctx.$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    )
                                                }, {
                                                  prepend: _withCtx(() => [
                                                    (_openBlock(), _createBlock(_component_v_checkbox, {
                                                      modelValue: _ctx.selectedTags,
                                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedTags) = $event)),
                                                      key: i + tag.id,
                                                      class: "pa-0 ma-0",
                                                      onClick: _withModifiers(($event: any) => (_ctx.selectTag(tag)), ["stop"]),
                                                      value: _ctx.isSelectedTag(tag)
                                                    }, null, 8, ["modelValue", "onClick", "value"]))
                                                  ]),
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_select_filled, {
                                                      modelValue: tag.partitionTag,
                                                      "onUpdate:modelValue": [($event: any) => ((tag.partitionTag) = $event), ($event: any) => (
                                                                _ctx.updateTag(tag, $event)
                                                            )],
                                                      items: _ctx.partitionTags,
                                                      outlined: "",
                                                      "hide-details": "",
                                                      label: "Partition",
                                                      "item-value": "id",
                                                      density: "compact",
                                                      "item-title": (item) => item.name
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(tag.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["class"]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 256))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "logTab" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "justify-center"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (partition, index) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    cols: "8",
                    class: "pa-2",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        style: {"border-radius":"12px","background":"#f8f8f8"},
                        class: "pa-2 fill-height"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "title d-flex"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(partition.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "d-flex align-center justify-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.newTags[partition.key],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.newTags[partition.key]) = $event),
                                "append-inner-icon": "$add",
                                label: "Nom du nouveau journal",
                                color: "primary",
                                "onClick:appendInner": ($event: any) => (_ctx.createTag(partition)),
                                outlined: "",
                                dense: "",
                                "hide-details": ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick:appendInner"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "my-3"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partition.tags, (tag) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "logItem px-2 py-1 mr-2 mt-1 d-flex",
                                  style: {"width":"fit-content !important","float":"left"},
                                  key: tag.id,
                                  onClick: _withModifiers(($event: any) => (_ctx.editTag(tag)), ["stop"])
                                }, [
                                  (partition.type === 'Building')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createVNode(_component_v_icon, {
                                          dense: "",
                                          size: "“x-small”"
                                        }, {
                                          default: _withCtx(() => _cache[56] || (_cache[56] = [
                                            _createTextVNode("$fa-building")
                                          ])),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, _toDisplayString(tag.name), 1),
                                  (!_ctx.disabledDeleteTag(partition))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createVNode(_component_v_icon, {
                                          dense: "",
                                          size: "“x-small”",
                                          onClick: _withModifiers(($event: any) => (_ctx.checkDeleteTag(tag.id)), ["stop"])
                                        }, {
                                          default: _withCtx(() => _cache[57] || (_cache[57] = [
                                            _createTextVNode("$oss-trash")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_10))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, {
          key: "accessRightTab",
          value: "accessRightTab"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              style: {"border-radius":"12px","background":"#f8f8f8"},
              class: "pa-2 fill-height"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "8",
                  class: "title d-flex"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accessRightPartition.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "d-flex align-center justify-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.newTags[_ctx.accessRightPartition.key],
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newTags[_ctx.accessRightPartition.key]) = $event)),
                      "append-inner-icon": "$add",
                      label: "Nom de la nouvelle cellule",
                      color: "primary",
                      "onClick:appendInner": _cache[14] || (_cache[14] = ($event: any) => (_ctx.createTag(_ctx.accessRightPartition))),
                      outlined: "",
                      dense: "",
                      "hide-details": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "my-3"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessRightPartition.tags, (tag) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "list-group-item logItem px-2 py-1 mr-2 mt-1 d-flex",
                        style: {"width":"fit-content !important","float":"left"},
                        key: tag.id,
                        onClick: _withModifiers(($event: any) => (_ctx.editTag(tag)), ["stop"])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(tag.name), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_v_icon, {
                            dense: "",
                            size: "“x-small”",
                            onClick: _withModifiers(($event: any) => (_ctx.checkDeleteTag(tag.id)), ["stop"])
                          }, {
                            default: _withCtx(() => _cache[58] || (_cache[58] = [
                              _createTextVNode("$oss-trash")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ], 8, _hoisted_13))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDialog,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.deleteDialog) = $event)),
      title: "Supprimer",
      error: true,
      onValid: _ctx.deleteTag,
      validLoading: _ctx.deleteLoading,
      width: "60vw"
    }, {
      default: _withCtx(() => _cache[59] || (_cache[59] = [
        _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("h4", null, "Attention : cette étiquette est utilisée."),
          _createElementVNode("h4", null, "Êtes-vous sûr(e) de vouloir supprimer cette étiquette ?")
        ], -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.errorTag,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.errorTag) = $event)),
      timeout: 2000,
      location: "end"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.errorTag = false)),
          variant: "text"
        }, {
          default: _withCtx(() => _cache[60] || (_cache[60] = [
            _createTextVNode(" Close ")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(" Le tag " + _toDisplayString(_ctx.isExistingTagName) + " existe déjà ", 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.showTagDialog)
      ? (_openBlock(), _createBlock(_component_TagEditionDialog, {
          key: 0,
          modelValue: _ctx.showTagDialog,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.showTagDialog) = $event)),
          currentTag: _ctx.currentTag,
          companyId: _ctx.companyId,
          distribution: _ctx.distribution,
          onUpsertedTag: _cache[20] || (_cache[20] = ($event: any) => (_ctx.resetTag()))
        }, null, 8, ["modelValue", "currentTag", "companyId", "distribution"]))
      : _createCommentVNode("", true),
    (_ctx.mergeDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 1,
          modelValue: _ctx.mergeDialog,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.mergeDialog) = $event)),
          title: "Fusionner",
          actions: _ctx.actions,
          "min-width": "600px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MergeTags, {
              tagsToMerge: _ctx.selectedTags,
              companyId: _ctx.companyId,
              actions: _ctx.actions,
              onTagsMerged: _cache[21] || (_cache[21] = ($event: any) => (_ctx.afterTagsMerged()))
            }, null, 8, ["tagsToMerge", "companyId", "actions"])
          ]),
          _: 1
        }, 8, ["modelValue", "actions"]))
      : _createCommentVNode("", true),
    (_ctx.partitionDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 2,
          modelValue: _ctx.partitionDialog,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.partitionDialog) = $event)),
          onValid: _cache[27] || (_cache[27] = ($event: any) => (_ctx.updatePartition())),
          onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.selectedPartition = null)),
          validDisabled: !_ctx.partitionValid,
          validLoading: _ctx.updatePartitionLoading,
          "min-width": "600px"
        }, {
          default: _withCtx(() => [
            (_ctx.selectedPartition)
              ? (_openBlock(), _createBlock(_component_v_form, {
                  key: 0,
                  modelValue: _ctx.partitionValid,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.partitionValid) = $event)),
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.selectedPartition.name,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedPartition.name) = $event)),
                              outlined: "",
                              label: "Nom",
                              rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                              density: "compact"
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            (
                                _ctx.selectedPartition.rules &&
                                _ctx.selectedPartition.rules.rootAccountableAccounts
                            )
                              ? (_openBlock(), _createBlock(_component_v_combobox_filled, {
                                  key: 0,
                                  modelValue: _ctx.selectedPartition.rules.rootAccountableAccounts,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.selectedPartition.rules.rootAccountableAccounts) = $event)),
                                  label: "Un de ces comptes racines",
                                  multiple: "",
                                  outlined: "",
                                  dense: "",
                                  chips: "",
                                  "deletable-chips": "",
                                  "item-disabled": "",
                                  rules: [_ctx.rules.onlyNumbers]
                                }, null, 8, ["modelValue", "rules"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "validDisabled", "validLoading"]))
      : _createCommentVNode("", true),
    (_ctx.dialogCreatePartitionTag)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 3,
          modelValue: _ctx.dialogCreatePartitionTag,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.dialogCreatePartitionTag) = $event)),
          title: "Ajouter une partition générique",
          onClose: _cache[31] || (_cache[31] = ($event: any) => (_ctx.dialogCreatePartitionTag = false)),
          onValid: _cache[32] || (_cache[32] = ($event: any) => {
                _ctx.createPartitionTag();
                _ctx.dialogCreatePartitionTag = false;
            }),
          validDisabled: !_ctx.partitionName,
          "min-width": "600px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "pa-2 my-2 elevation-0",
              style: {"border-radius":"12px","background":"#f8f8f8"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "pr-2 d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.partitionName,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.partitionName) = $event)),
                      outlined: "",
                      label: "Nom de la partition",
                      "hide-details": "",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "validDisabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.isErrorMessageTagToPartitionTag,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.isErrorMessageTagToPartitionTag) = $event)),
      color: "error"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn_icon, {
          icon: "$oss-close",
          color: "white",
          size: "small",
          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.isErrorMessageTagToPartitionTag = false))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.tagError) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}